/* eslint-disable */
/* prettier-ignore */
// Generated by elegant-router
// Read more: https://github.com/soybeanjs/elegant-router

import type { RouteComponent } from "vue-router";
import type { LastLevelRouteKey, RouteLayout } from "@elegant-router/types";

import BaseLayout from "@/layouts/base-layout/index.vue";
import BlankLayout from "@/layouts/blank-layout/index.vue";

export const layouts: Record<RouteLayout, RouteComponent | (() => Promise<RouteComponent>)> = {
  base: BaseLayout,
  blank: BlankLayout,
};

export const views: Record<LastLevelRouteKey, RouteComponent | (() => Promise<RouteComponent>)> = {
  403: () => import("@/views/_builtin/403/index.vue"),
  404: () => import("@/views/_builtin/404/index.vue"),
  500: () => import("@/views/_builtin/500/index.vue"),
  "iframe-page": () => import("@/views/_builtin/iframe-page/[url].vue"),
  login: () => import("@/views/_builtin/login/index.vue"),
  "ad-serving-data_data": () => import("@/views/ad-serving-data/data/index.vue"),
  "ad-serving-data_fraud-source": () => import("@/views/ad-serving-data/fraud-source/index.vue"),
  "ad-serving-data_material-statistics": () => import("@/views/ad-serving-data/material-statistics/index.vue"),
  apikey: () => import("@/views/apikey/index.vue"),
  "app-manage_app-list": () => import("@/views/app-manage/app-list/index.vue"),
  "app-manage_app-store-detail": () => import("@/views/app-manage/app-store-detail/[packageName].vue"),
  "app-manage_app-user": () => import("@/views/app-manage/app-user/index.vue"),
  "app-manage_monitor": () => import("@/views/app-manage/monitor/index.vue"),
  "app-manage_store-review": () => import("@/views/app-manage/store-review/index.vue"),
  "function_hide-child_one": () => import("@/views/function/hide-child/one/index.vue"),
  "function_hide-child_three": () => import("@/views/function/hide-child/three/index.vue"),
  "function_hide-child_two": () => import("@/views/function/hide-child/two/index.vue"),
  "function_multi-tab": () => import("@/views/function/multi-tab/index.vue"),
  function_request: () => import("@/views/function/request/index.vue"),
  "function_super-page": () => import("@/views/function/super-page/index.vue"),
  function_tab: () => import("@/views/function/tab/index.vue"),
  "function_toggle-auth": () => import("@/views/function/toggle-auth/index.vue"),
  home: () => import("@/views/home/index.vue"),
  manage_logprocessmgr: () => import("@/views/manage/logprocessmgr/index.vue"),
  manage_menu: () => import("@/views/manage/menu/index.vue"),
  manage_role: () => import("@/views/manage/role/index.vue"),
  "manage_user-detail": () => import("@/views/manage/user-detail/[id].vue"),
  manage_user: () => import("@/views/manage/user/index.vue"),
  "report-monitor": () => import("@/views/report-monitor/index.vue"),
  "statistics_ab-test": () => import("@/views/statistics/ab-test/index.vue"),
  "statistics_ad-detail": () => import("@/views/statistics/ad-detail/index.vue"),
  "statistics_ad-event": () => import("@/views/statistics/ad-event/index.vue"),
  "statistics_app-event-mnage": () => import("@/views/statistics/app-event-mnage/index.vue"),
  "statistics_churn-statistics": () => import("@/views/statistics/churn-statistics/index.vue"),
  "statistics_cohort-analysis": () => import("@/views/statistics/cohort-analysis/index.vue"),
  "statistics_game-level": () => import("@/views/statistics/game-level/index.vue"),
  "statistics_network-status-distribution": () => import("@/views/statistics/network-status-distribution/index.vue"),
  "statistics_report-download": () => import("@/views/statistics/report-download/index.vue"),
  "statistics_roas-adgroup-detail": () => import("@/views/statistics/roas-adgroup-detail/index.vue"),
  "statistics_roas-adgroups": () => import("@/views/statistics/roas-adgroups/index.vue"),
  "statistics_roas-analysis": () => import("@/views/statistics/roas-analysis/index.vue"),
  "statistics_roas-app-config": () => import("@/views/statistics/roas-app-config/index.vue"),
  "statistics_roas-compare": () => import("@/views/statistics/roas-compare/index.vue"),
  "statistics_user-activity-query": () => import("@/views/statistics/user-activity-query/index.vue"),
  tools: () => import("@/views/tools/index.vue"),
  "user-center": () => import("@/views/user-center/index.vue"),
  "user-segment-query_user-segment-analysis": () => import("@/views/user-segment-query/user-segment-analysis/index.vue"),
  "user-segment-query_user-segment-label": () => import("@/views/user-segment-query/user-segment-label/index.vue"),
};
